import React, { useState } from "react";

function MainSection() {
  const missions = [
    { id: 1, name: "Mission #1" },
    { id: 2, name: "Mission #2" },
    { id: 3, name: "Mission #3" },
  ];
  const [tab, setTab] = useState(missions[0].name);
  const tabHandler = (e, value) => {
    e.preventDefault();
    setTab(value);
  };
  return (
    <section className="binduz-er-about-us-area pb-60">
      <div className=" container">
        <div className="row">
          <div className=" col-lg-12">
            <div className="binduz-er-about-us-thumb">
              <img
                src={require(`../../assets/images/about-thumb.jpg`).default}
                alt=""
              />
            </div>
          </div>
          <div className=" col-lg-6">
            <div className="binduz-er-about-us-content">
              <h2 className="binduz-er-title">UK EXPRESS</h2>
              <p>"UK EXPRESS" ಇದು ನಿಮ್ಮದೇ ವೆಬ್ ಪೇಜ್. ಇದು ನಾಡಿನ ಸಮಸ್ತ ಜನರ ಸುದ್ದಿ ಪುಟ. ಉತ್ತರ ಕನ್ನಡ ಜಿಲ್ಲೆಯ ಜನರ ಮನಸ್ಸು ಉತ್ತರ ಕನ್ನಡ ಜಿಲ್ಲೆಯ ವಿಸ್ತೀರ್ಣಕ್ಕಿಂತ ವಿಶಾಲವಾಗಿದೆ. ಈ ವಿಶಾಲ ಹೃದಯದ ಜನರಿಗೆ ಜಿಲ್ಲೆಯ ಸಮಗ್ರ ಸುದ್ದಿ ತಲುಪಿಸಬೇಕು. ಈ ಪುಟದ ಮೂಲಕ ನಾಡಿನ, ದೇಶ ವಿದೇಶದ ಸಮಸ್ತ ಜನತೆಗೆ ನಾನಾ ತರದ ಮಾಹಿತಿ ನೀಡಬೇಕು ಎನ್ನುವ ಕಾರಣಕ್ಕೆ ಈ ಪುಟ ರಚಿಸಲಾಗಿದೆ.
                </p>
            </div>
          </div>
          <div className=" col-lg-6">
            <div className="binduz-er-about-us-content">
              <h4 className="binduz-er-title">About Us (ನಮ್ಮ ಬಗ್ಗೆ)</h4>
              <p>
              "UK EXPRESS" ಪುಟ ಇಂದು (ದಿನಾಂಕ) ರಚನೆ ಆದದ್ದಲ್ಲ. ನಾವು ಅನೇಕ ವರ್ಷಗಳಿಂದ ಜಿಲ್ಲೆಯ ಜನರ ಜೀವನಾಡಿಗಳಾಗಿದ್ದೇವೆ. ಈವರೆಗೆ ನಾವು "UK EXPRESS" ಹೆಸರಲ್ಲಿ ಸಾಮಾಜಿಕ ಜಾಲತಾಣ ಫೇಸ್ಬುಕ್, ವಾಟ್ಸಪ್ ಮೂಲಕ ಅನೇಕ ಸುದ್ದಿಗಳನ್ನು ನೀಡಿದ್ದೇವೆ. ಸಾವಿರಾರು ಸಂಖ್ಯೆಯಲ್ಲಿ ವಾಟ್ಸಪ್ ಗುಂಪುಗಳನ್ನು ರಚಿಸಿಕೊಂಡಿದ್ದೇವೆ. ನಮ್ಮದೇ ಅಕ್ಷರಗಳ ಮೂಲಕ ಜಿಲ್ಲೆಯ ಅನೇಕ ಬದಲಾವಣೆಗೆ, ಅಭಿವೃದ್ಧಿಗೆ ಕಾರಣರಾಗಿದ್ದೇವೆ. ಅನೇಕ ಜನಸಾಮಾನ್ಯರ ಕಷ್ಟಗಳಿಗೆ ಸ್ಪಂದಿಸಿದ್ದೇವೆ. ಅನೇಕರ ಸಾಮಾಜಿಕ, ಸರ್ಕಾರಿ ಕಚೇರಿ ಕೆಲಸ ಕಾರ್ಯಗಳ ಸಮಸ್ಯೆ ಪರಿಹರಿಸಿದ್ದೇವೆ ಎಂದು ಹೇಳಿಕೊಳ್ಳಲು ನಮಗೆ ಖಂಡಿತವಾಗಿ ಹೆಮ್ಮೆ ಎನಿಸುತ್ತದೆ.
              </p>
            </div>
          </div>
        </div>
          <h2>Why Choose Us (ನಮ್ಮನ್ನು ಏಕೆ ಆಯ್ಕೆ ಮಾಡಬೇಕು?)</h2>
        <div className="row">
          <div className=" col-lg-3 col-md-6">
            <div className="binduz-er-about-us-box">
              <div className="binduz-er-icon">
                <img
                  src={require(`../../assets/images/icon/2.png`).default}
                  alt=""
                />
              </div>
              <h4 className="binduz-er-title">ನಮ್ಮ ಕಾರ್ಯ ಮತ್ತು ಹಣಕಾಸಿನ ಸ್ವಾಯತ್ತತೆ</h4>
              <p>
              ವೆಬ್ ಪೇಜ್, ನ್ಯೂಸ್ ಪೋರ್ಟಲ್ ಎಂದರೆ ನಮಗೂ ಒಂದಿಷ್ಟು ಖರ್ಚುಗಳಿರುತ್ತವೆ. ನಾವು ಜನರಿಂದ ನಾನಾ ಹೆಸರಲ್ಲಿ ಹಣ ಕೇಳುವುದಿಲ್ಲ, ಚಂದಾ ನೀಡಿ ಎನ್ನುವುದಿಲ್ಲ, ವಸೂಲಿ ಅಂತೂ ಇಲ್ಲವೇ ಇಲ್ಲ. ನಾವು ಯಾವುದೇ ಕಾರಣಕ್ಕೂ ನಮ್ಮ ಜನಕ್ಕೆ ಹೊರೆ ಆಗುವುದಿಲ್ಲ. 24 ಗಂಟೆಯೂ ನಿಮ್ಮ "UK EXPRESS" ಕಾರ್ಯ ನಿರ್ವಹಿಸುತ್ತದೆ.
              </p>
            </div>
          </div>
          <div className=" col-lg-3 col-md-6">
            <div className="binduz-er-about-us-box">
              <div className="binduz-er-icon">
                <img
                  src={require(`../../assets/images/icon/3.png`).default}
                  alt=""
                />
              </div>
              <h4 className="binduz-er-title">ನಿಮ್ಮ ಸಹಕಾರ ನಮ್ಮ ಶಕ್ತಿ</h4>
              <p>
              ನಿಮ್ಮಲ್ಲಿ ಈ ನೆಲದ ಮಾನ್ಯ ಕಾನೂನಿನಡಿ ನಡೆಯುವ ಯಾವುದೇ ಕಾರ್ಯಕ್ರಮವಿದ್ದರೂ, ನಮಗೊಂದು ಜಾಹೀರಾತು ನೀಡಿ ಸಹಕರಿಸಿ ಎಂದಷ್ಟೇ ನಾವು ಕೇಳುತ್ತೇವೆ. ಸುದ್ದಿ ಮಾಧ್ಯಮಗಳ ಖರ್ಚು ವೆಚ್ಚ ಸರಿದೂಗಿಸುವ ಜವಾಬ್ದಾರಿಯಲ್ಲಿ ನೀವೂ ಪಾಲುದಾರರಾದರೆ ನಮಗೂ ನಿರಾಳವಾಗುತ್ತದೆ.
              </p>
            </div>
          </div>
          <div className=" col-lg-3 col-md-6">
            <div className="binduz-er-about-us-box">
              <div className="binduz-er-icon">
                <img
                  src={require(`../../assets/images/icon/4.png`).default}
                  alt=""
                />
              </div>
              <h4 className="binduz-er-title">ನ್ಯಾಯದ ಮಾರ್ಗದಲ್ಲಿ ನಮ್ಮ ನಂಬಿಕೆ</h4>
              <p>
              ನಾವು ನ್ಯಾಯದ ಮಾರ್ಗದಲ್ಲಿಯೇ ಸಾಗುತ್ತೇವೆ ಎನ್ನುವ ಬಲವಾದ ನಂಬಿಕೆ ನಮಗಿದೆ. ನಿಮಗೂ ಅದೇ ಭರವಸೆ ನೀಡುತ್ತೇವೆ.
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-60 align-items-center">
          {/* <div className=" col-lg-6">
            <div className="binduz-er-about-play-thumb">
              <img
                src={
                  require(`../../assets/images/about-play-thumb.png`).default
                }
                alt=""
              />
              <div className="binduz-er-play">
                <a className="binduz-er-video-popup" href="#">
                  <i className="fas fa-play"></i>
                </a>
              </div>
            </div>
          </div> */}
          <div className=" col-lg-6">
            <div className="binduz-er-about-play-content">
              <h3 className="binduz-er-title">Our Commitment (ನಮ್ಮ ಬದ್ದತೆ)</h3>
              {/* <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                {missions &&
                  missions.length > 0 &&
                  missions.map((missionItem) => (
                    <li
                      key={missionItem.id + Math.random()}
                      className="nav-item"
                      role="presentation"
                    >
                      <a
                        onClick={(e) => tabHandler(e, missionItem.name)}
                        className={`nav-link  ${
                          missionItem.name === tab ? "active" : ""
                        }`}
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        href="#pills-home"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                      >
                        {missionItem.name}
                      </a>
                    </li>
                  ))}
              </ul> */}
              {/* <div className="tab-content" id="pills-tabContent">
                {missions &&
                  missions.length > 0 &&
                  missions.map((missionItem) => (
                    <div
                      key={missionItem.id + Math.random()}
                      className={`tab-pane fade ${
                        missionItem.name === tab ? "active show" : ""
                      }`}
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    > */}
                      <div className="binduz-er-text">
                        <p>
                        ಸರ್ಕಾರಿ ಕೆಲಸ ಕಾರ್ಯ ಎಂದಾಗ ಜನರಿಗೆ ಸಹಜವಾಗೇ "ಏಜೆಂಟರೆನೋ?" ಎನ್ನುವ ಶಬ್ದ ನೆನಪಾಗುತ್ತದೆ. ಆದರೆ "UK EXPRESS" ಎಂದೂ ಏಜೆಂಟ್ ಕೆಲಸ ಮಾಡಿಲ್ಲ, ಮುಂದೆ ಮಾಡುವುದೂ ಇಲ್ಲ. "ನಮ್ಮದ್ದೇನಿದ್ದರೂ ನೇರ ನುಡಿ, ನೇರ ನಡೆ" ಇದು ನಮ್ಮ ಓದುಗರಿಗೂ ಗೊತ್ತಿದೆ. "ನಮ್ಮಿಂದಾಗಿ ಒಂದಿಷ್ಟು ಜನಕ್ಕೆ ಒಳಿತಾದರೆ ಸಾಕು" ಎನ್ನುವ ಮನೋಭಾವನೆಯಲ್ಲಿ "UK EXPRESS" ಕಾರ್ಯ ನಿರ್ವಹಿಸುತ್ತಿದೆ.
                          </p>
                      </div>
                    {/* </div
                   ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainSection;
